<template lang="html">
  <div class="sub-main column subview-container client">
		<div v-if="user" class="sub-page column">
      <section class="details-bar column activity-container container-background">
          <div class='row container activity-container'>
              <div class='row avatar'>
                  <div class='ctn-back' @click="goBack"><span class="icon-arrow-back" /></div>
                  <div class='ctn-avatar'><img :src="client.picture" alt='' /></div>
                  <div>
                      <div class='bold details-bar-username'>{{user.first_name}} {{user.last_name}}</div>
                      <div>Client de <span class='bold'>{{`${client.main_advisor.first_name} ${client.main_advisor.last_name}`}}</span> chez <span class='bold'>{{user.office.name}}</span></div>
                  </div>
              </div>
              <div class="row infos">
                  <div class="column">
                      <div class="label bold">E-MAIL</div>
                      <div class="content">{{user.email}}</div>
                  </div>
                  <div class="column">
                      <div class="label bold">TELEPHONE</div>
                      <div class="content">{{user.phone}}</div>
                  </div>
                  <div class="column">
                      <div class="label bold">ADRESSE</div>
                      <div class="content">{{user.address}}</div>
                  </div>
              </div>
              <div class="ctn-cta">
                  <div class="btn btn-grey" @click="showClientModal = true">
                      Editer
                  </div>
                  <div class='toggle'><toggle-input @change="updateClientStatus" :value="user.enabled" /></div>
              </div>
          </div>
      </section>

      <!-- <section class="column situation-container container-background2">

      </section>
      <section class="row client-details-container">

      </section>       -->
      <div class="contentrow row">
        <div class="inner-row row">
          <div class="half infos">
            <div class="heading row">
              <div class="title row">
                <span class="icon-fiche-client-info"></span>
                Informations
              </div>
              <!-- <div class="add">
                <div class="btn btn-gold" @click="modals.editClient=true">
                  Edit
                </div>
              </div> -->
            </div>
            <div class="boding column">
              <div class="row info">
                <div class="label"> Nom complet </div>
                <div class="value"> {{ user.first_name }} {{ user.last_name }}</div>
              </div>
              <div class="row info">
                <div class="label">Date de naissance</div>
                <div class="value">{{ user.birthdate }}</div>
              </div>
              <div class="row info">
                <div class="label">Téléphone</div>
                <div class="value">{{ user.phone || '-' }}</div>
              </div>
              <div class="row info">
                <div class="label">Adresse mail</div>
                <div class="value">{{ user.email || '-' }}</div>
              </div>
              <div class="row info">
                <div class="label">Adresse postal</div>
                <div class="value" >{{ user.address || '-' }}</div>
              </div>
              <div class="row info">
                <div class="label">Ville</div>
                <div class="value" >{{ user.city || '-' }}</div>
              </div>
              <div class="row info">
                <div class="label">Code postal</div>
                <div class="value" >{{ user.zipcode || '-' }}</div>
              </div>
              <!-- <div class="column info tags">
                <div class="label">Centres d'intérêts</div>
                <div class="value row">
                  <div class="tag" v-for="(tag, key) in client.center_of_interest" v-bind:key="key">
                    {{ tag.wordpress_tag_name }}
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="half infos patrimoine column">
            <div class="heading row">
              <div class="title row">
                <span class="icon-fiche-client-paysage"></span>
                Paysage Patrimonial
              </div>
              <div class="add row">
                <!-- <div class="btn btn-gold">
                  Edit
                </div> -->
                <!-- <router-link :to="{name: 'PatrimonialLandscape', params: {clientId: client.id}}" class="btn btn-gold">
                  Voir
                </router-link> -->
              </div>
            </div>
            <div class="boding column" >
              <div class="no-patrimoine empty column" v-if="!estate.success">
                Votre client doit remplir <br/>
                son Paysage Patrimonial pour <br/>
                pouvoir commencer à investir.
                <!-- <div class="btn btn-red" @click="sendRelance">
                  <span class="icon-button-relance"></span>
                  Envoyer une relance
                </div> -->
              </div>
              <div class="patrimoines take-place" v-else>
                <div class="row info">
                  <div class="label">Age</div>
                  <div class="value">{{ estate.user.birthdate || '-' }}</div>
                </div>
                <div class="row info">
                  <div class="label">Métier</div>
                  <div class="value">{{ estate.user.job || '-' }}</div>
                </div>
                <div class="row info">
                  <div class="label">CSP</div>
                  <div class="value">{{ estate.user.professional_category || '-' }}</div>
                </div>
                <div class="row info">
                  <div class="label">Enfants</div>
                  <div class="value">{{ estate.user.kids.length }} à charge</div>
                </div>
                <div class="info row">
                  <div class="label">Revenu annuel</div>
                  <div class="value">{{ estate.private_estate_totals.total_incomes || '-' }}</div>
                </div>
                <div class="info row">
                  <div class="label">Immobilier</div>
                  <div class="value">{{ estate.private_estate_totals.immobilier || '-' }}</div>
                </div>
                <div class="info row">
                  <div class="label">Epargne</div>
                  <div class="value">{{ estate.private_estate_totals.total_savings || '-' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="half column appointment">

        </div>
      </div>
      <baseModal :data="userModal" :show="showClientModal" @close="showClientModal = false" :content="contentModal" />

		</div>
  </div>
</template>

<style lang="scss">

</style>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import ModalEditClient from '../modals/ClientModal'
import baseModal from '@/common/components/baseModal'
export default {
	name: 'Client',
	components: {
		baseModal
	},
	data () {
		return {
			showClientModal: false,
			contentModal: ModalEditClient,
      // user: null
      // estate: {}
		}
	},
	mounted () {
		console.log(this.user, this.client)
	},
	beforeRouteEnter (to, from, next) {
    store.commit('LOADER_IN')
    let promiseClient = store.dispatch('getClientById', to.params.id)
    let promiseEstate = store.dispatch('getClientEstateById', to.params.id)
    Promise.all([promiseClient, promiseEstate])
    .then(() => {
			next()
    })
    .catch(() => {
			next(false)
    })
    .finally(() => {
			store.commit('LOADER_OUT')
    })
	},
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    updateClientStatus (e) {
      const id = this.user.id
      const enable = e
      store.commit('LOADER_IN')
      if (enable) {
        this.$store.dispatch('enableClient', id)
        .finally(() => {
          store.commit('LOADER_OUT')
        })
      } else {
        this.$store.dispatch('disableClient', id)
        .finally(() => {
          store.commit('LOADER_OUT')
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      client: 'client',
      estate: 'estate'
    }),
    user () {
      return this.client.user
    },
    userModal () {
      return { ...this.client, office: this.user.office.name }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Details.vue?39f56ba0